







import { Component, Vue } from 'vue-property-decorator'
import marked from 'marked'

@Component<PrivacyContent>({
  created () {
    this.init()
  }
})
export default class PrivacyContent extends Vue {
  text = ''

  async init (): Promise<void> {
    const r = await fetch('/privacy.md')
    const text = await r.text()
    this.text = marked(text)
  }
}
